import React, { useState } from "react";
import { GetAccess } from "../../../utils/RolesandAccess";
import ViewVendor from "./ViewVendor";
import { ViewMoreIcon } from "../../../assets/icons";
import useDeleteData from "../../../hooks/useDeleteData";
import CreateOrEdit from "./form";
import { ScreenOpen } from "../../../utils/OtherFunctions";

function ViewMore({ fetcher, data, vendorList }) {
  const { handleDelete } = useDeleteData();
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showFile, setShowFile] = useState(false);
  const handleClose = () => setShowFile(false);


  function EditScreen(){
    ScreenOpen({link:"ConnectVendor/update",id:data.id})
    setShowMyModal(true)
  }

  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl dropdown bg-white cursor-pointer relative">
        <ViewMoreIcon/>
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white text-left rounded-xl w-20 absolute -left-20 -top-1">
            <div className="grid p-1 rounded-t">
              <span
                className="p-1 hover:bg-navhover hover:rounded-lg"
                onClick={() => setShowFile(true)}
              >
                View
              </span>
              {GetAccess("information_edit") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer"
                  onClick={EditScreen}
                >
                  Edit
                </span>
              )}
              {GetAccess("information_delete") && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg"
                  onClick={() => {
                      handleDelete({
                        url: `/ConnectVendor/${data?.id}/`,
                        data:{data:{"id":data?.id}},
                        id: data?.id,
                        value: data?.vendor_name,
                        fetcher:fetcher
                      });
                  }}
                >
                  Delete
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <CreateOrEdit onClose={handleOnClose} vendorList={vendorList} visible={showMyModal} data={data} refreshData={fetcher} />
      <ViewVendor data={data} onClose={handleClose} visible={showFile}/>
    </>
  );
}

export default ViewMore;
